<template lang="pug">
  .reseted-password
    .icon
      i.far.fa-check-circle
    .message
      | {{ $t('reset_password.check_your_email') }}
    .link-back
      router-link(:to="{ name: 'LoginPage' }") {{ $t('reset_password.ok') }} 
    

</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .reseted-password {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 4px 16px 0 rgba(176, 186, 197, 0.56);
    margin: auto;
    padding: 50px;
    text-align: center;

    .icon {
      font-size: 150px;
      margin-bottom: 20px;
    }

    .message {
      font-weight: 700;
      margin-bottom: 20px;
      text-transform: uppercase;
    }
  }
</style>
